import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/app/[locale]/not-found.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/light_of_empire_front/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/light_of_empire_front/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/var/www/light_of_empire_front/shared/ui/HudCorners/HudCorners.module.scss");
